// extracted by mini-css-extract-plugin
export default {"container":"VTimeSlider_container_3r6-g","bar":"VTimeSlider_bar_XZuDD","played":"VTimeSlider_played_3x8_K","loaded":"VTimeSlider_loaded_2KqnH"};